import { Deserializable } from '../deserializable';

export class UploadedDocument implements Deserializable {
  public UploadedDocumentID: number;
  public DocumentCode: string;
  public FileNames: string;
  public SuppliedByAgentID?: number;
  public SuppliedByBranchUserID?: number;
  public SuppliedByDirectCustomerID?: number;
  public UploadedDate: Date;
  public SuppliedByStaffID?: number;
  public DocumentName: string;
  public UploadedDocumentDataID?: number;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
